import _ from 'lodash'

const DEFAULT_MODEL = [
  {
    field: 'card_track1',
    type: 'string',
  },
  {
    field: 'card_track2',
    type: 'string'
  },
  {
    field: 'card_parsed_account',
    type: 'string'
  },
  {
    field: 'phone_number',
    type: 'string'
  },
  {
    field: 'original_amount',
    type: 'number',
    validation: (v) => v > 2
  },
  {
    field: 'customer_id',
    type: 'number'
  }
];

export function getData(getStore, extraModel = null) {
  const applicationData = getStore().app && getStore().app.x_data;
  if(!applicationData) {
    console.error('ApplicationData not found');
    return false;
  }

  const MODEL = _.compact(_.concat(DEFAULT_MODEL, extraModel));
  const result = {};

  _.each(MODEL, (o) => {
    result[o.field] = applicationData[o.field];
  });

  return result;
}

export function validator(getStore, extraModel = null) {
  const applicationData = getStore().app && getStore().app.x_data;
  if(!applicationData) {
    console.error('ApplicationData not found');
    return false;
  }

  const MODEL = _.compact(_.concat(DEFAULT_MODEL, extraModel));

  const result = _.reduce(MODEL, (prevStep, nextStep) => {
    const value = applicationData[nextStep.field];
    const extraValidation =  nextStep.validation ? nextStep.validation(value) : true;

    const isValid = !!(value && typeof value === nextStep.type && extraValidation);

     //console.log(nextStep.field, isValid);

    return prevStep && isValid
  }, true);

  // console.log('Validation', MODEL, extraModel, result);

  return result
}



// WEBPACK FOOTER //
// ./src/components/Applications/CashReload/models/transaction.js